import "./App.css";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import Login from "./components/screens/login";
import Sidebar from "./components/sidebar/sidebar";

const hiTechTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#1f458D",
    },
    secondary: {
      main: "#111827",
    },
    background: {
      default: "#EEF1F5",
      paper: "#FFFFFF",
    },
    text: {
      primary: "#0B0F1A",
      secondary: "rgba(11, 15, 26, 0.70)",
    },
    divider: "rgba(15, 23, 42, 0.12)",
  },
  shape: {
    borderRadius: 4.2,
  },
  typography: {
    fontFamily: [
      "Inter",
      "system-ui",
      "-apple-system",
      "Segoe UI",
      "Roboto",
      "Ubuntu",
      "Cantarell",
      "Noto Sans",
      "sans-serif",
    ].join(","),
    h5: { fontWeight: 700, letterSpacing: 0.2 },
    h6: { fontWeight: 700, letterSpacing: 0.2 },
    body1: { color: "#0B0F1A" },
    body2: { color: "rgba(11, 15, 26, 0.72)" },
    button: { textTransform: "none", fontWeight: 600 },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: "#EEF1F5",
          color: "#0B0F1A",
        },
        "*": {
          scrollbarColor: "rgba(17, 24, 39, 0.35) rgba(0, 0, 0, 0.08)",
        },
        "*::-webkit-scrollbar": {
          width: 10,
          height: 10,
        },
        "*::-webkit-scrollbar-thumb": {
          background: "rgba(17, 24, 39, 0.25)",
          border: "2px solid rgba(255, 255, 255, 0.7)",
          borderRadius: 999,
        },
        "*::-webkit-scrollbar-track": {
          background: "rgba(0, 0, 0, 0.06)",
          borderRadius: 999,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: "none",
          border: "1px solid rgba(15, 23, 42, 0.10)",
          boxShadow: "0 12px 32px rgba(15, 23, 42, 0.10)",
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundImage: "none",
          backgroundColor: "rgba(255, 255, 255, 0.85)",
          borderBottom: "1px solid rgba(15, 23, 42, 0.10)",
          backdropFilter: "blur(10px)",
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundImage: "none",
          backgroundColor: "rgba(245, 247, 250, 0.95)",
          borderRight: "1px solid rgba(15, 23, 42, 0.10)",
          backdropFilter: "blur(8px)",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 4.2,
        },
        contained: {
          boxShadow: "0 10px 24px rgba(15, 23, 42, 0.12)",
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        size: "small",
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 4.2,
          backgroundColor: "#FFFFFF",
        },
        notchedOutline: {
          borderColor: "rgba(15, 23, 42, 0.18)",
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: 4.2,
          margin: "4px 8px",
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          color: "#0B0F1A",
          borderBottom: "1px solid rgba(15, 23, 42, 0.08)",
        },
        head: {
          fontWeight: 700,
          color: "#0B0F1A",
          backgroundColor: "rgba(15, 23, 42, 0.04)",
        },
      },
    },
    MuiDataGrid: {
      styleOverrides: {
        root: {
          borderColor: "rgba(15, 23, 42, 0.10)",
        },
        columnHeaders: {
          backgroundColor: "rgba(15, 23, 42, 0.04)",
          color: "#0B0F1A",
          fontWeight: 700,
        },
        cell: {
          color: "#0B0F1A",
        },
      },
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={hiTechTheme}>
      <CssBaseline />
      <BrowserRouter>
        <Routes>
          <Route path="/dashboard" element={<Sidebar />} />
          <Route path="/app-login" element={<Login />} />
          <Route path="*" element={<Navigate to="/dashboard" />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
